import React from "react";
import "@emran-alhaddad/saudi-riyal-font/index.css";
import "../../assets/dirham-symbol.css";

export const DIRHAM_CHAR = "\u00ea";

export const currencySymbolHtml = (currency) => {
  if (!currency) return "";
  if (currency === "AED") {
    return `<span class="dirham-symbol" style="font-family:'UAESymbol',sans-serif;font-size:1.15em;vertical-align:middle;">${DIRHAM_CHAR}</span>`;
  }
  if (currency === "SAR") {
    return `<span class="icon-saudi_riyal"></span>`;
  }
  return String(currency);
};

const CurrencySymbol = ({ currency, withParentheses = true }) => {
  if (currency === "SAR") {
    return (
      <span className="currency-symbol">
        <span className="icon-saudi_riyal"></span>
      </span>
    );
  }

  if (currency === "AED") {
    return (
      <span className="currency-symbol">
        <span className="dirham-symbol">&#xea;</span>
      </span>
    );
  }

  if (!currency) return null;

  return withParentheses ? ` (${currency})` : currency;
};

export default CurrencySymbol;
